angular.module('impactx.approval').directive('ixApprovalSupplierIcon', function() {
    return {
        scope: {
            hideIcon: '=',
            size: "="
        },
        restrict: 'E',
        templateUrl: 'shared/approval/templates/approval-supplier-icon.tmpl.html',
        link: function(scope) {
            scope.$watch('size', function(newValue) {
                scope.sizeClass = 'basket-approval-supplier-divider-size-1';
                if(newValue) {
                    scope.sizeClass = 'basket-approval-supplier-divider-size-' + newValue;
                }
            }, true);
        }
    }
});